<template>
  <div class="not-found-view website">
    <website-header />
    <div class="_body">
      <div class="container">
        <h1>
          404 Not found
        </h1>
      </div>
      <c-divider />
      <website-footer />
    </div>
  </div>
</template>

<script>
import CDivider from 'shared/components/CDivider.vue';
import WebsiteFooter from '@/components/WebsiteFooter.vue';
import WebsiteHeader from '@/components/WebsiteHeader.vue';

export default {
  name: 'NotFoundView',
  components: { WebsiteHeader, WebsiteFooter, CDivider },
};
</script>

<style
  scoped
  type="text/scss"
  lang="scss"
>
@import "shared/assets/scss/box-shadow";

.not-found-view {
  .container {
    min-height: calc(100vh - 60rem);
  }
}
</style>
